<template>
  <router-view />
</template>

<script>
  // rebuild
  export default {
    name: 'App',
  }
</script>
